module.exports = __webpack_public_path__ + "static/img/wb_bg_tel.e1264a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jieju/wb_bg_tel.png
// module id = msfC
// module chunks = 1